import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Header, Container, Grid } from 'semantic-ui-react';
import Image from '../../atoms/Image';
import Call from '../../molecules/Call';
import ContactRail from '../../molecules/ContactRail';
import Email from '../../molecules/Email';
import HoursOfOperation from '../../molecules/HoursOfOperation';
import { allDayHoursAreUndefined } from '../../molecules/HoursOfOperation/utils';
import Location from '../../molecules/Location';
import './Contact.css';

// Returns whether you're on a mobile device
function isMobileDevice() {
  if (typeof navigator !== 'undefined') {
    if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) return true;
  }
  return false;
}
var Contact = /*#__PURE__*/function (_React$Component) {
  _inherits(Contact, _React$Component);
  var _super = _createSuper(Contact);
  function Contact() {
    _classCallCheck(this, Contact);
    return _super.apply(this, arguments);
  }
  _createClass(Contact, [{
    key: "renderHours",
    value:
    // Renders hours vertically
    function renderHours() {
      var hours = this.props.hours;
      return allDayHoursAreUndefined(hours) ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, null, "Hours"), /*#__PURE__*/React.createElement(HoursOfOperation, {
        hours: hours,
        displayOption: "grouped"
      }));
    }

    // Renders a plain map
  }, {
    key: "renderMap",
    value: function renderMap() {
      var _this$props = this.props,
        address = _this$props.address,
        businessName = _this$props.businessName;
      return /*#__PURE__*/React.createElement(Location, {
        address: address,
        businessName: businessName,
        showMap: true,
        showAddress: false
      });
    }

    // Renders phone number, email, address and name as text depending on availability of props
  }, {
    key: "renderText",
    value: function renderText() {
      var _this$props2 = this.props,
        businessName = _this$props2.businessName,
        phoneNumber = _this$props2.phoneNumber,
        email = _this$props2.email,
        address = _this$props2.address,
        name = _this$props2.name;
      return /*#__PURE__*/React.createElement("div", null, phoneNumber && /*#__PURE__*/React.createElement(Call, {
        phoneNumber: phoneNumber
      }), email && /*#__PURE__*/React.createElement(Email, {
        email: email
      }), name && /*#__PURE__*/React.createElement(Header, {
        className: "locationName",
        as: "h4"
      }, name), address && /*#__PURE__*/React.createElement(Location, {
        address: address,
        businessName: businessName
      }));
    }

    // Integrates text sections into larger components with images and maps
  }, {
    key: "renderTextSection",
    value: function renderTextSection() {
      var _this$props3 = this.props,
        header = _this$props3.header,
        image = _this$props3.image,
        showMap = _this$props3.showMap,
        hours = _this$props3.hours,
        name = _this$props3.name;

      // Hours not included in props
      // Logic: If the hours aren't included, it displays a side block view. If an image
      // is specified, the side block is the image; if not, it's a map.
      if (!hours) {
        return /*#__PURE__*/React.createElement(Grid, {
          stackable: true
        }, /*#__PURE__*/React.createElement(Grid.Column, {
          className: "contact-graphic",
          width: 10
        }, image === '' ? this.renderMap() : /*#__PURE__*/React.createElement(Image, {
          src: image
        })), /*#__PURE__*/React.createElement(Grid.Column, {
          width: 5,
          verticalAlign: "middle"
        }, header !== '' && /*#__PURE__*/React.createElement(Header, null, header), name && /*#__PURE__*/React.createElement(Header, null, name), this.renderText()));
      }

      // Hours included in props
      // Logic: It includes either an image, a map, both, or neither
      // No "neither" case for v1 to remove chances of odd spacing

      // Both an image and a map
      if (showMap && image !== '') {
        return /*#__PURE__*/React.createElement(Grid, {
          stackable: true
        }, /*#__PURE__*/React.createElement(Grid.Row, {
          columns: 2
        }, /*#__PURE__*/React.createElement(Grid.Column, {
          className: "contact-graphic",
          width: 10
        }, this.renderMap()), /*#__PURE__*/React.createElement(Grid.Column, {
          width: 5,
          verticalAlign: "middle"
        }, header === '' ? /*#__PURE__*/React.createElement(Header, null, "Contact") : /*#__PURE__*/React.createElement(Header, null, header), this.renderText())), /*#__PURE__*/React.createElement(Grid.Row, {
          columns: 2,
          verticalAlign: "middle"
        }, /*#__PURE__*/React.createElement("div", {
          className: "left floated right aligned five wide column hours"
        }, this.renderHours()), /*#__PURE__*/React.createElement(Grid.Column, {
          className: "contact-graphic",
          width: 10
        }, /*#__PURE__*/React.createElement(Image, {
          src: image,
          centered: true
        }))));
      }

      // Otherwise includes either an image or a map
      return /*#__PURE__*/React.createElement(Grid, {
        stackable: true
      }, /*#__PURE__*/React.createElement(Grid.Column, {
        className: "contact-graphic",
        width: 10
      }, image === '' ? this.renderMap() : /*#__PURE__*/React.createElement(Image, {
        src: image
      })), /*#__PURE__*/React.createElement(Grid.Column, {
        width: 5,
        verticalAlign: "middle",
        className: "contact-content"
      }, header === '' ? /*#__PURE__*/React.createElement(Header, null, header) : /*#__PURE__*/React.createElement(Header, null, "Contact"), this.renderText(), /*#__PURE__*/React.createElement("br", null), this.renderHours()));
    }
  }, {
    key: "renderRail",
    value: function renderRail() {
      var _this$props4 = this.props,
        phoneNumber = _this$props4.phoneNumber,
        email = _this$props4.email,
        address = _this$props4.address,
        buttonColor = _this$props4.buttonColor;
      var railItems = [];
      var callItem = phoneNumber ? {
        type: 'call',
        props: {
          phoneNumber: phoneNumber
        }
      } : {};
      var emailItem = email ? {
        type: 'email',
        props: {
          email: email
        }
      } : {};
      var locationItem = address ? {
        type: 'location',
        props: {
          address: address
        }
      } : {};
      railItems.push(callItem, emailItem, locationItem);
      return isMobileDevice() ? /*#__PURE__*/React.createElement(ContactRail, {
        items: railItems,
        iconsOnly: true,
        grouped: true,
        buttonColor: buttonColor
      }) : /*#__PURE__*/React.createElement(ContactRail, {
        items: railItems,
        iconsOnly: true,
        vertical: true,
        grouped: true,
        buttonColor: buttonColor
      });
    }

    // Rail of Email, Location, Call depending on what's available
  }, {
    key: "renderRailSection",
    value: function renderRailSection() {
      var image = this.props.image;

      // Image use case
      return /*#__PURE__*/React.createElement(Grid, {
        stackable: true
      }, /*#__PURE__*/React.createElement(Grid.Row, {
        centered: true,
        columns: 2
      }, /*#__PURE__*/React.createElement(Grid.Column, {
        floated: "left",
        verticalAlign: "middle",
        width: 11
      }, image === '' ? this.renderMap() : /*#__PURE__*/React.createElement(Image, {
        src: image
      })), /*#__PURE__*/React.createElement(Grid.Column, {
        width: 5,
        verticalAlign: "middle"
      }, /*#__PURE__*/React.createElement(Grid.Row, {
        verticalAlign: "middle"
      }, this.renderRail(), /*#__PURE__*/React.createElement("p", null), this.renderHours()))));
    }
  }, {
    key: "render",
    value: function render() {
      var as = this.props.as;
      if (as === 'text') {
        return /*#__PURE__*/React.createElement(Container, {
          className: "contact-container"
        }, this.renderTextSection());
      }
      return /*#__PURE__*/React.createElement(Container, {
        className: "contact-container"
      }, this.renderRailSection());
    }
  }]);
  return Contact;
}(React.Component);
export { Contact as default };
Contact.defaultProps = {
  businessName: '',
  name: '',
  as: 'text',
  email: '',
  buttonColor: 'default',
  header: '',
  hours: null,
  image: '',
  showMap: false,
  phoneNumber: ''
};
Contact.propOptions = {
  buttonColor: ['primary', 'secondary', 'default'],
  header: ['Contact', 'Contact Us']
};
Contact.dataPropsMap = {
  address: ['business', 'primary_location'],
  email: ['business', 'primary_location', 'email'],
  phoneNumber: ['business', 'primary_location', 'phone_number'],
  hours: ['business', 'primary_location', 'hours']
};